const toOrderDetailPrice = (raw) => {
  return {
    totalPrice: raw.total,
    shippingMethodPrice: raw.shippingPrice,
    paymentMethodPrice: raw.paymentMethodPrice || void 0,
    discountedAmount: raw.discountedAmount || 0,
    subtotalAmount: raw.subtotal || 0,
    ...!!raw.donation && {
      donation: {
        amount: raw.donation,
        totalWithDonation: raw.finalWithDonation
      }
    }
  };
};
const toAddress = (raw) => {
  if (!raw) {
    return void 0;
  }
  const fieldNames = [
    "firstName",
    "lastName",
    "streetName",
    "streetNumber",
    "additionalStreetInfo",
    "city",
    "postalCode",
    "region",
    "countryCode",
    "externalId"
  ];
  if (raw.__typename === "OrderAddress") {
    return fieldNames.reduce((m, fieldName) => ({ ...m, [fieldName]: raw[fieldName] ?? "" }), {});
  }
};
export {
  toAddress,
  toOrderDetailPrice
};
//# sourceMappingURL=orders.js.map
